import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';
import { browserHistory } from 'react-router';
// import ReactGA from 'react-ga';

import api, { getAuthToken } from '../../api';

import { loadCart } from './cart.js';
import IubendaCookieSolution from '../../utils/iubenda';
import {
  fkmxLogin,
  fkmxSignup,
} from '../../components/shared/lib/farmakomMetrics';
import { SET_GUEST_CHECKOUT } from './checkout';

// ------------------------------------
// Constants
// ------------------------------------
const CREATE_USER_REQUEST = 'farmakom/user/CREATE_USER_REQUEST';
const CREATE_USER_SUCCESS = 'farmakom/user/CREATE_USER_SUCCESS';
const CREATE_USER_FAILURE = 'farmakom/user/CREATE_USER_FAILURE';

const LOGIN_REQUEST = 'farmakom/user/LOGIN_REQUEST';
const LOGIN_SUCCESS = 'farmakom/user/LOGIN_SUCCESS';
const LOGIN_FAILURE = 'farmakom/user/LOGIN_FAILURE';

const LOGIN_FACEBOOK_REQUEST = 'farmakom/user/LOGIN_FACEBOOK_REQUEST';
const LOGIN_FACEBOOK_SUCCESS = 'farmakom/user/LOGIN_FACEBOOK_SUCCESS';
const LOGIN_FACEBOOK_FAILURE = 'farmakom/user/LOGIN_FACEBOOK_FAILURE';

const LOAD_REQUEST = 'farmakom/user/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/user/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/user/LOAD_FAILURE';

const SAVE_ACCOUNT_REQUEST = 'farmakom/user/SAVE_ACCOUNT_REQUEST';
const SAVE_ACCOUNT_SUCCESS = 'farmakom/user/SAVE_ACCOUNT_SUCCESS';
const SAVE_ACCOUNT_FAILURE = 'farmakom/user/SAVE_ACCOUNT_FAILURE';

const LOGOUT = 'farmakom/user/LOGOUT';

const CHECK_EMAIL_AVAILABILITY_REQUEST =
  'farmakom/user/CHECK_EMAIL_AVAILABILITY_REQUEST';
const CHECK_EMAIL_AVAILABILITY_SUCCESS =
  'farmakom/user/CHECK_EMAIL_AVAILABILITY_SUCCESS';
const CHECK_EMAIL_AVAILABILITY_FAILURE =
  'farmakom/user/CHECK_EMAIL_AVAILABILITY_FAILURE';

const PASSWORD_RESET_REQUEST = 'farmakom/user/PASSWORD_RESET_REQUEST';
const PASSWORD_RESET_SUCCESS = 'farmakom/user/PASSWORD_RESET_SUCCESS';
const PASSWORD_RESET_FAILURE = 'farmakom/user/PASSWORD_RESET_FAILURE';

const PASSWORD_CHANGE_REQUEST = 'farmakom/user/PASSWORD_CHANGE_REQUEST';
const PASSWORD_CHANGE_SUCCESS = 'farmakom/user/PASSWORD_CHANGE_SUCCESS';
const PASSWORD_CHANGE_FAILURE = 'farmakom/user/PASSWORD_CHANGE_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// THUNK
export function createUser(
  user,
  isCheckout = false,
  isRegister,
  hasRicetta = false,
  form
) {
  const userToSave = { ...user };

  const {
    email,
    password,
    provider,
    providerId,
    hasAcceptedPrivacyPolicy,
    hasSubscribedToNewsletter,
  } = userToSave;
  let { billing, shipping } = userToSave;

  if (!provider && (billing.city || billing.province)) {
    // sistemo billing
    const billingCityArray = billing.city.value.split('|');
    billing.city = billingCityArray[0];
    billing.province = billingCityArray[1];

    // sistemo shipping
    if (shipping.sameAsBilling) {
      shipping = {
        ...userToSave.billing,
      };
      delete shipping.taxCode;
      delete shipping.vatNumber;
      delete shipping.isCompany;
      delete shipping.sdiCode;
      delete shipping.pec;

      // Su shipping esiste un solo name,
      // no firstName, lastName, company....
      delete shipping.firstname;
      delete shipping.lastname;
      delete shipping.company;

      if (userToSave.billing.isCompany === 'true') {
        shipping.name = userToSave.billing.company;
        shipping.address2 =
          userToSave.billing.firstname + ' ' + userToSave.billing.lastname;
      } else {
        shipping.name =
          userToSave.billing.firstname + ' ' + userToSave.billing.lastname;
      }
    } else {
      if (shipping.city && shipping.city.value) {
        const shippingCityArray = shipping.city.value.split('|');
        shipping.city = shippingCityArray[0];
        shipping.province = shippingCityArray[1];
      }
      delete shipping.sameAsBilling;
    }
  }

  if (!provider && (!billing.city || !billing.province)) {
    delete shipping.sameAsBilling;
    delete shipping.name;
    delete shipping.country;
  }

  const userToCreate = {
    email,
    password,
    provider,
    providerId,
    billing,
    shipping,
    hasAcceptedPrivacyPolicy,
    hasSubscribedToNewsletter,
  };

  return function(dispatch, getState) {
    const { endpoint, method, headers, body } = api.createUser(userToCreate);
    const storeid = getState().store.data.storeId;
    const hasIubendaCookieSolution = getState().store.data.features
      .hasIubendaCookieSolution;
    const iubendaApiKey = getState().store.data.integrazioni.iubenda.apiKey;
    const farmakomMetricsApiKey = getState().store.data.integrazioni.metrics
      .apiKey;

    const headersWithStoreId = {
      ...headers,
      storeid,
    };

    // Login Request
    dispatch({ type: CREATE_USER_REQUEST, payload: userToCreate });

    fetch(endpoint, { method, headers: headersWithStoreId, body })
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            // IUBENDA SALVO CONSENSO
            if (hasIubendaCookieSolution) {
              const iubenda = new IubendaCookieSolution(
                hasIubendaCookieSolution,
                iubendaApiKey
              );
              iubenda.saveConsentSignUp(
                {
                  id: data.user.id,
                  ...userToCreate,
                },
                form
              );
            }

            dispatch({
              type: CREATE_USER_SUCCESS,
              payload: data.user,
            });
            dispatch({
              type: LOGIN_SUCCESS,
              payload: data.user,
            });

            // FKMX TRACK LOGIN
            if (!!farmakomMetricsApiKey) {
              fkmxSignup(user);
            }

            localStorage.setItem('token', data.authToken);
            localStorage.setItem('user', JSON.stringify(data.user));

            // GOOGLE ANALYTICS - REGISTRAZIONE UTENTE
            // ReactGA.event({
            //   category: 'Utente',
            //   action: 'Registrazione',
            //   label: isCheckout ? 'In checkout' : 'Da menù',
            // });

            if (isCheckout) {
              if (hasRicetta) {
                browserHistory.push('/ricetta');
              } else {
                browserHistory.push('/spedizione');
              }
            }
            if (isRegister) {
              browserHistory.push('/profilo');
            }
          });
        } else {
          response.json().then(data => {
            dispatch({
              type: CREATE_USER_FAILURE,
              payload: data && data.message,
            });
          });
        }
      })
      .catch(error => {
        dispatch({
          type: CREATE_USER_FAILURE,
          payload: 'Errore generico durante la registrazione',
        });
      });
  };
}

// API CALL
export function saveAccount(userId, userData) {
  const billing = { ...userData.billing };
  const shipping = { ...userData.shipping };

  if (billing.city) {
    const billingCityArray = billing.city.value.split('|');
    billing.city = billingCityArray[0];
    billing.province = billingCityArray[1];
  }

  if (shipping.city && shipping.city.value) {
    const shippingCityArray = shipping.city.value.split('|');
    shipping.city = shippingCityArray[0];
    shipping.province = shippingCityArray[1];
  }

  if (userData.billing) {
    // Sistemiamo isCompany a boolean e, se non c'è la P.IVA
    // la settiamo a stringa vuota
    if (userData.billing.isCompany === 'false') {
      billing.isCompany = false;
      billing.vatNumber = '';
    } else {
      billing.isCompany = true;
    }
  }

  const userDataToSave = { ...userData, billing, shipping };

  return {
    [RSAA]: {
      ...api.saveAccount(userId, userDataToSave),
      types: [SAVE_ACCOUNT_REQUEST, SAVE_ACCOUNT_SUCCESS, SAVE_ACCOUNT_FAILURE],
    },
  };
}

// API CALL
export function saveAccountEmailPassword(userId, userData) {
  return {
    [RSAA]: {
      ...api.saveAccount(userId, userData),
      types: [SAVE_ACCOUNT_REQUEST, SAVE_ACCOUNT_SUCCESS, SAVE_ACCOUNT_FAILURE],
    },
  };
}

// THUNK
export function login(
  credentials,
  isCheckout = false,
  hasPrescription = false
) {
  return function(dispatch, getState) {
    if (credentials.email && credentials.password) {
      const { endpoint, method, headers, body } = api.login(credentials);
      const storeid = getState().store.data.storeId;
      const farmakomMetricsApiKey = getState().store.data.integrazioni.metrics
        .apiKey;

      const headersWithStoreId = {
        ...headers,
        storeid,
      };

      // Login Request
      dispatch({ type: LOGIN_REQUEST, payload: credentials });

      fetch(endpoint, { method, headers: headersWithStoreId, body })
        .then(response => {
          if (response.ok) {
            response.json().then(data => {
              dispatch({
                type: LOGIN_SUCCESS,
                payload: data.user,
              });
              dispatch({
                type: SET_GUEST_CHECKOUT,
                payload: false,
              });

              // FKMX TRACK LOGIN
              if (!!farmakomMetricsApiKey) {
                fkmxLogin(data.user);
              }

              localStorage.setItem('token', data.authToken);
              localStorage.setItem('user', JSON.stringify(data.user));

              if (isCheckout) {
                if (hasPrescription) {
                  browserHistory.push('/ricetta');
                } else {
                  browserHistory.push('/spedizione');
                }
              } else {
                browserHistory.push('/');
              }
            });
          } else {
            // Non ok...
            if (response.status === 401) {
              // Autenticazione fallita
              dispatch(authError('Email o password errate'));
            } else {
              // Errore server != 401
              dispatch(authError('Errore di comunicazione con il server'));
            }
          }
        })
        .catch(error => {
          dispatch(authError('Errore di comunicazione con il server'));
        });
    }
  };
}

export function authUser(user) {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  };
}

export function authError(errorMessage) {
  return {
    type: LOGIN_FAILURE,
    payload: errorMessage,
  };
}

// THUNK
export function loginFacebook(credentials, isCheckout = false) {
  return function(dispatch, getState) {
    if (credentials.email && credentials.id) {
      const { endpoint, method, headers, body } = api.loginFacebook(
        credentials
      );
      const storeid = getState().store.data.storeId;
      const farmakomMetricsApiKey = getState().store.data.integrazioni.metrics
        .apiKey;

      const headersWithStoreId = {
        ...headers,
        storeid,
      };

      // Login Request
      dispatch({ type: LOGIN_FACEBOOK_REQUEST, payload: credentials });

      fetch(endpoint, { method, headers: headersWithStoreId, body })
        .then(response => {
          if (response.ok) {
            response.json().then(data => {
              if (data.error) {
                dispatch({
                  type: LOGIN_FACEBOOK_FAILURE,
                  payload: data.message,
                });
              } else {
                dispatch({
                  type: LOGIN_FACEBOOK_SUCCESS,
                  payload: data.user,
                });

                // FKMX TRACK LOGIN
                if (!!farmakomMetricsApiKey) {
                  fkmxLogin(data.user);
                }

                localStorage.setItem('token', data.authToken);
                localStorage.setItem('user', JSON.stringify(data.user));

                // GOOGLE ANALYTICS - LOGIN UTENTE
                // ReactGA.event({
                //   category: 'Utente',
                //   action: 'Login',
                //   label: isCheckout ? 'In checkout' : 'Da menù',
                // });

                if (isCheckout) {
                  browserHistory.push('/spedizione');
                } else {
                  // Eliminato 22/03/2017
                  //browserHistory.push('/profilo');
                }
              }
            });
          } else {
            // Non ok...
            if (response.status === 401) {
              // Autenticazione fallita
              dispatch(authError('Errore login facebook'));
            } else {
              // Errore server != 401
              dispatch(authError('Errore di comunicazione con il server'));
            }
          }
        })
        .catch(error => {
          dispatch(authError('Errore di comunicazione con il server'));
        });
    }
  };
}

export function authUserFacebook(user) {
  return {
    type: LOGIN_FACEBOOK_SUCCESS,
    payload: user,
  };
}

export function authErrorFacebook(errorMessage) {
  return {
    type: LOGIN_FACEBOOK_FAILURE,
    payload: errorMessage,
  };
}

export function logoutUser() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  browserHistory.push('/');
  // return { type: LOGOUT };
  return function(dispatch) {
    dispatch({ type: LOGOUT });
    dispatch({ type: SET_GUEST_CHECKOUT, payload: false });
  };
}

export function loadUser(user) {
  return function(dispatch, getState) {
    const authToken = getAuthToken();
    if (!authToken) {
      const loadCartAction = loadCart();
      return dispatch(loadCartAction);
    }

    const { endpoint, method, headers, body } = api.getUser();
    const storeid = getState().store.data.storeId;
    const farmakomMetricsApiKey = getState().store.data.integrazioni.metrics
      .apiKey;

    const headersWithStoreId = {
      ...headers,
      storeid,
    };

    // Load Request
    dispatch({ type: LOAD_REQUEST });

    fetch(endpoint, { method, headers: headersWithStoreId, body })
      .then(response => {
        if (response.ok) {
          return response.json().then(data => {
            dispatch({
              type: LOAD_SUCCESS,
              payload: data,
            });
            localStorage.setItem('user', JSON.stringify(data));
            // FKMX TRACK LOGIN
            if (!!farmakomMetricsApiKey) {
              fkmxLogin(data);
            }
          });
        } else {
          // Non ok...
          if (response.status === 401) {
            // Autenticazione fallita
            dispatch({
              type: LOAD_FAILURE,
            });
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            dispatch({ type: LOGOUT });
          } else {
            // Errore server != 401
            dispatch(authError('Errore di comunicazione con il server'));
          }
        }
      })
      .then(() => {
        const loadCartAction = loadCart();
        return dispatch(loadCartAction);
      })
      .catch(error => {
        dispatch(authError('Errore di comunicazione con il server'));
      });
  };
}

// API CALL
export function passwordReset(email) {
  return {
    [RSAA]: {
      ...api.passwordReset(email),
      types: [
        PASSWORD_RESET_REQUEST,
        PASSWORD_RESET_SUCCESS,
        PASSWORD_RESET_FAILURE,
      ],
    },
  };
}

// API CALL
export function passwordChange(token, email) {
  return {
    [RSAA]: {
      ...api.passwordChange(token, email),
      types: [
        PASSWORD_CHANGE_REQUEST,
        PASSWORD_CHANGE_SUCCESS,
        PASSWORD_CHANGE_FAILURE,
      ],
    },
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  authenticated: false,
  data: {
    billing: {
      name: '',
      isCompany: false,
    },
    shipping: {},
  },
  error: '',
  loading: false,
  emailAvailable: true,
  passwordResetRequested: false,
  passwordChanged: false,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        authenticated: true,
        data: {},
        error: '',
      };
    case CREATE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        authenticated: false,
        data: {},
        error: action.payload,
      };
    case SAVE_ACCOUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case SAVE_ACCOUNT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case SAVE_ACCOUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        authenticated: true,
        data: {
          ...state.data,
          ...action.payload,
        },
        error: '',
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        authenticated: false,
        data: {},
        error: action.payload,
      };
    case LOGIN_FACEBOOK_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOGIN_FACEBOOK_SUCCESS:
      return {
        ...state,
        loading: false,
        authenticated: true,
        data: {
          ...state.data,
          ...action.payload,
        },
        error: '',
      };
    case LOGIN_FACEBOOK_FAILURE:
      return {
        ...state,
        loading: false,
        authenticated: false,
        data: {},
        error: action.payload,
      };
    case LOGOUT:
      return {
        ...state,
        authenticated: false,
        data: { name: '', isCompany: 'false' },
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        authenticated: true,
        data: action.payload,
        error: '',
      };
    case CHECK_EMAIL_AVAILABILITY_REQUEST:
      return {
        ...state,
        emailAvailable: true,
        loading: true,
        error: '',
      };
    case CHECK_EMAIL_AVAILABILITY_SUCCESS:
      return {
        ...state,
        loading: false,
        emailAvailable: true,
        error: '',
      };
    case CHECK_EMAIL_AVAILABILITY_FAILURE:
      return {
        ...state,
        loading: false,
        emailAvailable: false,
        error: action.payload.message,
      };
    case PASSWORD_RESET_REQUEST:
      return {
        ...state,
        loading: true,
        authenticated: false,
        error: '',
        passwordResetRequested: false,
      };
    case PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        passwordResetRequested: true,
      };
    case PASSWORD_RESET_FAILURE:
      return {
        ...state,
        loading: false,
        authenticated: false,
        error: action.payload.message,
        passwordResetRequested: false,
      };
    case PASSWORD_CHANGE_REQUEST:
      return {
        ...state,
        loading: true,
        authenticated: false,
        error: '',
        passwordChanged: false,
      };
    case PASSWORD_CHANGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        passwordChanged: true,
      };
    case PASSWORD_CHANGE_FAILURE:
      return {
        ...state,
        loading: false,
        authenticated: false,
        error: action.payload.message,
        passwordChanged: false,
      };
    default:
      return state;
  }
}

// SELECTORS

export function getUserProfile(globalState) {
  const user = globalState.user.data;
  const userOk = {
    ...user,
    billing: {
      ...user.billing,
      isCompany: '' + user.billing.isCompany,
      city: {
        value: user.billing.city + '|' + user.billing.province,
        label: `${user.billing.city} (${user.billing.province})`,
      },
    },
    shipping: {
      ...user.shipping,
      city:
        user.shipping.country === 'Italia'
          ? {
              value: user.shipping.city + '|' + user.shipping.province,
              label: `${user.shipping.city} (${user.shipping.province})`,
            }
          : user.shipping.city,
    },
  };

  return userOk;
}
